/* eslint @typescript-eslint/no-explicit-any: "off" */

import { postJSON as postJSONBase } from "./base"
import {
    ServicesResponse,
    ServicesResponseWithValue,
} from "../models/api/services"

const apiPath = "Ajax/Service.asmx"

export const postJSON = (
    path: string,
    args: any,
    parsingCallback?: (response: ServicesResponse<any>) => any,
): Promise<any> =>
    postJSONBase(`${apiPath}/${path}`, args)
        .then(parsingCallback ?? defaultParsingCallback)
        .catch(catchResponse)

const defaultParsingCallback = (json: ServicesResponse<any>): any =>
    Array.isArray(json.d)
        ? json.d
        : Object.keys(json.d)
              .filter((x) => !x.startsWith("_"))
              .reduce<any>((prev, cur) => ({ ...prev, [cur]: json.d[cur] }), {})

const catchResponse = (response: Response): void => {
    if (!response.ok) {
        response.text &&
            response.text().then((body) => {
                if (__DEBUG__) {
                    console.error(
                        `Call to the API failed (${response.status}): ${body}`,
                    )
                }
            })
        throw response
    }
}

export function parseServicesCallbackWithValue<T>(
    json: ServicesResponseWithValue<T>,
): T {
    return json.d.Value
}
